<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="MeterConsumption"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      :id="formId"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpFormGroup
        name="consumer"
        :label="'Meter'|pgettext('MeterConsumption')"
        :helpTooltip="'The consuming meter'|pgettext('MeterConsumption')"
        labelColsMd="4"
        contentColsMd="8"
        required
        :labelAlign="labelAlign"
      >
        <UcMeterSelector
          :item="item"
          path="meter"
          :readonly="isReadOnly"
          required
          @optionSelected="evh_7789867021953041_optionSelected($event, {})"
        >
        </UcMeterSelector>
      </ItpFormGroup>
      <ItpFormGroup
        name="consumer"
        :label="'Consumer'|pgettext('MeterConsumption')"
        :helpTooltip="'The consumer of the resources'|pgettext('MeterConsumption')"
        labelColsMd="4"
        contentColsMd="8"
        required
        :labelAlign="labelAlign"
      >
        <UcCompanySelector
          :item="item"
          path="consumer"
          :readonly="isReadOnly"
          required
        >
        </UcCompanySelector>
      </ItpFormGroup>
      <ItpFormGroup
        name="unit"
        :label="'Unit'|pgettext('MeterConsumption')"
        :helpTooltip="'Unit of measurement'|pgettext('MeterConsumption')"
        labelColsMd="4"
        contentColsMd="3"
        :labelAlign="labelAlign"
        required
      >
        <ItpFormSelect2
          name="unit"
          v-model="item.unit"
          :options="units"
          valueField="symbol"
          textField="symbol"
          :readonly="isReadOnly"
          required
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        name="start"
        :label="'Start'|pgettext('MeterConsumption')"
        :helpTooltip="'Start reading and it\'s date'|pgettext('MeterConsumption')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="form-row"
        required
      >
        <div
          class="col"
        >
          <ItpFormInput
            type="number"
            name="start_reading"
            :placeholder="'Start reading'|pgettext('MeterConsumption|InputPlaceholder')"
            v-model="item.start.reading"
            :readonly="isReadOnly"
          >
          </ItpFormInput>
        </div>
        <div
          class="col"
        >
          <ItpFormDatetime
            type="date"
            name="start_date"
            :placeholder="'Start date'|pgettext('MeterConsumption|InputPlaceholder')"
            v-model="item.start.date"
            :readonly="isReadOnly"
          >
          </ItpFormDatetime>
        </div>
      </ItpFormGroup>
      <ItpFormGroup
        name="end"
        :label="'End'|pgettext('MeterConsumption')"
        :helpTooltip="'End reading and it\'s date'|pgettext('MeterConsumption')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="form-row"
        required
      >
        <div
          class="col"
        >
          <ItpFormInput
            type="number"
            name="end_reading"
            :placeholder="'End reading'|pgettext('MeterConsumption|InputPlaceholder')"
            v-model="item.end.reading"
            :readonly="isReadOnly"
          >
          </ItpFormInput>
        </div>
        <div
          class="col"
        >
          <ItpFormDatetime
            type="date"
            name="end_date"
            :placeholder="'End date'|pgettext('MeterConsumption|InputPlaceholder')"
            v-model="item.end.date"
            :readonly="isReadOnly"
          >
          </ItpFormDatetime>
        </div>
      </ItpFormGroup>
      <hr>
      </hr>
      <ItpFormGroup
        name="rental"
        :label="'Rental'|pgettext('MeterConsumption')"
        :helpTooltip="'The rental the consumption belongs to'|pgettext('MeterConsumption')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
      >
        <ItpFormSelect2
          name="rental"
          v-model="item.rental"
          :dataSource="b_4152404563918957_dataSource"
          valueField="id"
          textField="name"
          bind-object
          clearable
          use-option-template-for-selected-option
          optionTemplate="<UcSuggestRentalOption :option=&quot;option&quot;></UcSuggestRentalOption>"
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        name="non_billable"
        :label="'Non billable'|pgettext('MeterConsumption')"
        :helpTooltip="'Optional flag to exclude this consumption from billing processes'|pgettext('MeterConsumption')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
      >
        <ItpFormCheckbox
          name="non_billable"
          inline
          v-model="item.non_billable"
          :readonly="isReadOnly"
        >
        </ItpFormCheckbox>
      </ItpFormGroup>
      <ItpFormGroup
        name="billing_factor"
        :label="'Billing factor'|pgettext('MeterConsumption')"
        :helpTooltip="'Optional multiplier applied to consumption'|pgettext('MeterConsumption')"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
      >
        <ItpFormInput
          type="number"
          name="billing_factor"
          v-model="item.billing_factor"
          :readonly="isReadOnly"
        >
        </ItpFormInput>
      </ItpFormGroup>
      <ItpFormGroup
        name="tariff"
        :label="'Billing tariff'|pgettext('MeterConsumption')"
        :helpTooltip="'Tariff plan to use for billing'|pgettext('MeterConsumption')"
        labelColsMd="4"
        contentColsMd="4"
        :labelAlign="labelAlign"
      >
        <ItpFormSelect2
          name="tariff"
          v-model="item.tariff"
          :options="tariffs"
          valueField="id"
          textField="name"
          :readonly="isReadOnly"
        >
        </ItpFormSelect2>
      </ItpFormGroup>
      <ItpFormGroup
        name="unit_price"
        :label="'Unit price'|pgettext('MeterConsumption')"
        :helpTooltip="'Price per unit for billing'|pgettext('MeterConsumption')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
        contentClass="input-group"
        v-if="item.unit_price"
      >
        <ItpFormInput
          :placeholder="'Amount'|pgettext('MeterConsumption|InputPlaceholder')"
          type="number"
          name="unit_price_amount"
          v-model="item.unit_price.amount"
          class="col-8"
        >
        </ItpFormInput>
        <ItpFormSelect
          :placeholder="'Currency'|pgettext('MeterConsumption|InputPlaceholder')"
          name="currency"
          v-model="item.unit_price.currency"
          :options="currencies"
          textField="code"
          valueField="code"
          required
          clearable
          class="col-4"
        >
        </ItpFormSelect>
      </ItpFormGroup>
      <hr>
      </hr>
      <ItpFormGroup
        name="note"
        :label="'Note'|pgettext('MeterConsumption')"
        :helpTooltip="'Optional note or comment about this meter period'|pgettext('MeterConsumption')"
        labelColsMd="4"
        contentColsMd="8"
        :labelAlign="labelAlign"
      >
        <ItpFormTextarea
          name="note"
          v-model="item.note"
          :readonly="isReadOnly"
        >
        </ItpFormTextarea>
      </ItpFormGroup>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpBox
      class="mr-auto"
      v-if="oid && !item.locked"
    >
      <BtnDeleteResource
        :resource="item"
        :disabled="actions.submit.isRunning"
        tabindex="-1"
        @success="evh_2140198529698299_success($event, {})"
      >
      </BtnDeleteResource>
      <BtnLockResource
        :resource="item"
        :disabled="actions.submit.isRunning"
        tabindex="-1"
        class="ml-3"
        @success="evh_2434514588044777_success($event, {})"
      >
      </BtnLockResource>
    </ItpBox>
    <ItpButton
      :text="'Save'|pgettext('ModalButton')"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.submit.isRunning"
      :disabled="!forms[formName] || !forms[formName].submittable"
      v-if="!item.locked"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|pgettext('ModalButton')"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_2186679009640457_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class MeterConsumption extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  getPayload(...args: any[]) {
    const item = this.item
    return _.extend(item, {
      meter: { id: item.meter.id },
      unit_price: (item.unit_price && item.unit_price.amount != null) ? item.unit_price : null,
    });
  }

  @Prop({
    type: String,
    default: null,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: Object,
    default: null,
  })
  meter!: object;

  @Watch('meter')
  onMeter(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("meter")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return this.oid
      ? this.$fn.fetch('read_meter_consumption', { parameters: { id: this.oid } }).then(p => {
        if (p.unit_price == null) {
          p.unit_price = { amount: null, currency: null };
        }
        return p;
      })
      : this.$fn.schemaDefaults('CreateMeterConsumption', {
        meter: this.meter || {},
        unit: this.meter ? this.meter.unit : null,
        unit_price: { amount: null, currency: null }
      })
  }

  currencies!: any;

  async $$load_currencies() {
    return this.$fn.fetch('list_currency')
  }

  units!: any;

  async $$load_units() {
    return this.$fn.fetch('list_unit').then(d => _.orderBy(d, [p => p.symbol.toLowerCase()]))
  }

  formName!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  labelAlign!: any;
  isReadOnly!: any;

  async $$load_isReadOnly() {
    return this.item.locked || this.item.isReadonly
  }

  tariffs!: any;

  async $$load_tariffs() {
    return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'tariff' } })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_4152404563918957_dataSource!: any;
  dataMembers = ['item', 'currencies', 'units', 'formName', 'formId', 'labelAlign', 'isReadOnly', 'tariffs', 'ux', 'b_7315092382398562_modalBindings', 'b_4152404563918957_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        currencies: null,
        units: null,
        formName: "meterConsumption",
        formId: null,
        labelAlign: "right",
        isReadOnly: null,
        tariffs: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
        b_4152404563918957_dataSource: {
          name: "suggest_rental",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.oid ? this.$fn.gettext('Edit Meter Consumption') : this.$fn.gettext('Add Meter Consumption'),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_9452_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_9452, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_9458_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_9458, alias=undefined
    return {
      name: this.modalName,
      result: {
        ok: true,
        value: $event.data.response.data,
      }
      ,
    }
  }

  async act_1040167445267876_request_9456_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_9456, alias=submit
    return {
      operation: this.item.id ? 'update_meter_consumption' : 'create_meter_consumption',
      data: this.getPayload(),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_7789867021953041_setData_9460_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_7789867021953041_setData_9460, alias=undefined
    return {
      path: "item.unit",
      value: $event.data.unit,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_7789867021953041_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7789867021953041_optionSelected.executeFromDOM(this, event, scope);
  }

  async act_2140198529698299_closeModal_9462_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_2140198529698299_closeModal_9462, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async evh_2140198529698299_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2140198529698299_success.executeFromDOM(this, event, scope);
  }

  async act_2434514588044777_closeModal_9464_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_2434514588044777_closeModal_9464, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async evh_2434514588044777_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2434514588044777_success.executeFromDOM(this, event, scope);
  }

  async act_2186679009640457_closeModal_9466_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_2186679009640457_closeModal_9466, alias=undefined
    return {
      name: this.modalName,
      result: {
        cancel: true,
      }
      ,
    }
  }

  async evh_2186679009640457_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2186679009640457_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_9452: actions.CloseModalAction;
    evh_7315092382398562_close_9451: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_9454: actions.CloseComponentAction;
    evh_2248226175642056_close_9453: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_9458: actions.CloseModalAction;
    evh_1040167445267876_success_9457: actions.EventHandlerImpl;
    act_1040167445267876_request_9456: actions.RequestAction;
    evh_1040167445267876_submit_9455: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_7789867021953041_setData_9460: actions.SetDataAction;
    evh_7789867021953041_optionSelected_9459: actions.EventHandlerImpl;
    evh_7789867021953041_optionSelected: actions.EventHandlerGroup;
    act_2140198529698299_closeModal_9462: actions.CloseModalAction;
    evh_2140198529698299_success_9461: actions.EventHandlerImpl;
    evh_2140198529698299_success: actions.EventHandlerGroup;
    act_2434514588044777_closeModal_9464: actions.CloseModalAction;
    evh_2434514588044777_success_9463: actions.EventHandlerImpl;
    evh_2434514588044777_success: actions.EventHandlerGroup;
    act_2186679009640457_closeModal_9466: actions.CloseModalAction;
    evh_2186679009640457_clickPreventStop_9465: actions.EventHandlerImpl;
    evh_2186679009640457_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_9452 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_9452_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_9451 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_9452,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_9451],
      }
    );
    const act_2248226175642056_closeComponent_9454 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_9453 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_9454,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_9453],
      }
    );
    const act_1040167445267876_closeModal_9458 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_9458_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_9457 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_9458,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_request_9456 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_9456_getActionArgs,
        displayName: "submit",
        events: [evh_1040167445267876_success_9457],
      }
    );
    const evh_1040167445267876_submit_9455 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_9456,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_9455],
      }
    );
    const act_7789867021953041_setData_9460 = new actions.SetDataAction(
      {
        actionArgs: this.act_7789867021953041_setData_9460_getActionArgs,
        events: [],
      }
    );
    const evh_7789867021953041_optionSelected_9459 = new actions.EventHandlerImpl(
      {
        action: act_7789867021953041_setData_9460,
        event: "optionSelected",
        displayName: "setData",
      }
    );
    const evh_7789867021953041_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_7789867021953041_optionSelected_9459],
      }
    );
    const act_2140198529698299_closeModal_9462 = new actions.CloseModalAction(
      {
        actionArgs: this.act_2140198529698299_closeModal_9462_getActionArgs,
        events: [],
      }
    );
    const evh_2140198529698299_success_9461 = new actions.EventHandlerImpl(
      {
        action: act_2140198529698299_closeModal_9462,
        event: "success",
        displayName: "closeModal",
      }
    );
    const evh_2140198529698299_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_2140198529698299_success_9461],
      }
    );
    const act_2434514588044777_closeModal_9464 = new actions.CloseModalAction(
      {
        actionArgs: this.act_2434514588044777_closeModal_9464_getActionArgs,
        events: [],
      }
    );
    const evh_2434514588044777_success_9463 = new actions.EventHandlerImpl(
      {
        action: act_2434514588044777_closeModal_9464,
        event: "success",
        displayName: "closeModal",
      }
    );
    const evh_2434514588044777_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_2434514588044777_success_9463],
      }
    );
    const act_2186679009640457_closeModal_9466 = new actions.CloseModalAction(
      {
        actionArgs: this.act_2186679009640457_closeModal_9466_getActionArgs,
        events: [],
      }
    );
    const evh_2186679009640457_clickPreventStop_9465 = new actions.EventHandlerImpl(
      {
        action: act_2186679009640457_closeModal_9466,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_2186679009640457_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_2186679009640457_clickPreventStop_9465],
      }
    );
    return {
      act_7315092382398562_closeModal_9452,
      evh_7315092382398562_close_9451,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_9454,
      evh_2248226175642056_close_9453,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_9458,
      evh_1040167445267876_success_9457,
      act_1040167445267876_request_9456,
      evh_1040167445267876_submit_9455,
      evh_1040167445267876_submit,
      act_7789867021953041_setData_9460,
      evh_7789867021953041_optionSelected_9459,
      evh_7789867021953041_optionSelected,
      act_2140198529698299_closeModal_9462,
      evh_2140198529698299_success_9461,
      evh_2140198529698299_success,
      act_2434514588044777_closeModal_9464,
      evh_2434514588044777_success_9463,
      evh_2434514588044777_success,
      act_2186679009640457_closeModal_9466,
      evh_2186679009640457_clickPreventStop_9465,
      evh_2186679009640457_clickPreventStop,
      submit: act_1040167445267876_request_9456,
    }
  }
}

Vue.component("MeterConsumption", MeterConsumption);

</script>